import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';

export default (aval, bval) => {
  const a = JSON.parse(JSON.stringify(aval || {}));
  const b = JSON.parse(JSON.stringify(bval || {}));
  return (
    isEqual(a.locId, b.locId)
    && isEqual(a.unitId, b.unitId)
    && isEqual(a.supervisorId, b.supervisorId)
    && isEqual(a.studentId, b.studentId)
    && isEqual(a.duration, b.duration)
    && isEqual(a.patient, b.patient)
    && isEqual(a.patientDOB, b.patientDOB)
    && isEqual(a.proIds && a.proIds.sort(), b.proIds && b.proIds.sort())
    && isEqual(a.stepIds && a.stepIds.sort(), b.stepIds && b.stepIds.sort())
    && isEqual(a.flagIds && a.flagIds.sort(), b.flagIds && b.flagIds.sort())
    && isEqual(a.teeth && a.teeth.sort(), b.teeth && b.teeth.sort())
    && isEqual(a.grades && sortBy(a.grades, 'stepId'), b.grades && sortBy(b.grades, 'stepId'))
    && isEqual(
      a.comments && a.comments.student && a.comments.student.trim(),
      b.comments && b.comments.student && b.comments.student.trim(),
    )
    && isEqual(
      a.comments && a.comments.staff && a.comments.staff.trim(),
      b.comments && b.comments.staff && b.comments.staff.trim(),
    )
    && isEqual(
      a.comments && a.comments.staffPrivate && a.comments.staffPrivate.trim(),
      b.comments && b.comments.staffPrivate && b.comments.staffPrivate.trim(),
    )
  );
};
